<div class="header">
    <div class="filters">
        <div class="filter-options contractor-filter">
            <mat-radio-group aria-label="Select a location type" (change)="filterChanged($event)"
                [name]="'FilterOptionsGroup'" [(ngModel)]="filterValue" [ngModelOptions]="{standalone: true}">
                <mat-radio-button class="checkbox-margins" [value]="null">
                    All
                </mat-radio-button>
                <mat-radio-button class="checkbox-margins" [value]="'Teltonika'">
                    Teltonika
                </mat-radio-button>
                <mat-radio-button class="checkbox-margins" [value]="'Radius'">
                    Radius
                </mat-radio-button>
            </mat-radio-group>
        </div>
    </div>
    <div class="filters">
        <mat-form-field>
            <mat-date-range-input [rangePicker]="picker">
                <input [formControl]="startDate" matStartDate placeholder="Start date">
                <input [formControl]="endDate" matEndDate placeholder="End date">
            </mat-date-range-input>
            <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
    </div>
</div>
@if( displayLocation && deviceLocations.length>0 && errorFetchingData===false){
<div class="map-container">
    <huge-monorepo-base-map #mapComponent [locations]="deviceLocations" [calculateCenter]="true" [showTowerLegend]="true"
         [updateActionButtons]="true" [focusedZoom]="15" ></huge-monorepo-base-map>
</div>
}
@else if (displayLocation && deviceLocations.length==0 && errorFetchingData===false){
<p>No Locations For Device.</p>
}
@else if (displayLocation && errorFetchingData===true){
<p>Error Fetching Locations for Device</p>
}
@else if (!displayLocation){
  <div class="centered-content">
    <mat-spinner class="mainSpinner" [diameter]="40"></mat-spinner>
  </div>
}
